import React from 'react'

/**
 * Reading-progress bar. Driven entirely by `animation-timeline: scroll()`
 * in CSS — no scroll listener, no state, no re-renders.
 */
const ScrollProgress = () => <div className="scrollProgress" aria-hidden="true" />

export default ScrollProgress
